import React from 'react';

interface MessageIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const MessageIcon: React.FC<MessageIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.6588 18.6161C21.2155 16.8531 22.1602 
      14.5369 22.1602 12C22.1602 6.47715 17.683 2 
      12.1602 2C6.63731 2 2.16016 6.47715 2.16016 
      12C2.16016 17.5228 6.63731 22 12.1602 22H21.2138C22.0552 
      22 22.4766 21.1024 21.8816 20.5774L19.6588 18.6161Z"
      fill={color}
    />
  </svg>
);

export default MessageIcon;
